import { Observable } from 'rxjs';
import { PrivacyPolicyResponse } from '../models/privacy-policy-response.model';

export abstract class PrivacyPolicyRepository {
    abstract getPrivacyPolicy(): Observable<PrivacyPolicyResponse>;
}
